// 데이터 출처 : ??????????????????
// 데이터 출처 : 수정된 Carry / Return Roller Weight는 MMM. '25.6/27

const IMPACT_SPACING = 0.3;
const SAC_SPACING = 30;
const SAR_SPACING = 30;


export const idlerData = [         // carry-3rolls, return-1roll
    {
        beltWidth: 400,
        rollerDia: 89.1,
        carry: {
            // rollerWeight: 6.3,
            rollerWeight: 9.9,
            idlerWeight: 12.2,
            inertia: '',
        },
        return: {
            // rollerWeight: 5.1,
            rollerWeight: 7.8,
            idlerWeight: 6.5,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 6.1,
            idlerWeight: 7.5,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 14.7,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 28.7,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 29.3,
            inertia: '',
        }
    },
    {
        beltWidth: 450,
        rollerDia: 89.1,
        carry: {
            // rollerWeight: 6.9,
            rollerWeight: 10.8,
            idlerWeight: 13.0,
            inertia: '',
        },
        return: {
            // rollerWeight: 5.5,
            rollerWeight: 8.6,
            idlerWeight: 6.9,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 6.6,
            idlerWeight: 8.0,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 15.8,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 29.7,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 30.4,
            inertia: '',
        }
    },
    {
        beltWidth: 500,
        rollerDia: 89.1,
        carry: {
            // rollerWeight: 7.5,
            rollerWeight: 11.4,
            idlerWeight: 13.7,
            inertia: '',
        },
        return: {
            // rollerWeight: 6.0,
            rollerWeight: 9.3,
            idlerWeight: 7.4,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 7.1,
            idlerWeight: 8.5,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 16.6,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 31.3,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 31.5,
            inertia: '',
        }
    },
    {
        beltWidth: 600,
        rollerDia: 114.3,
        carry: {
            // rollerWeight: 8.1,
            rollerWeight: 12.6,
            idlerWeight: 19.7,
            inertia: '',
        },
        return: {
            // rollerWeight: 8.9,
            rollerWeight: 10.7,
            idlerWeight: 10.8,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 9.1,
            idlerWeight: 11.0,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 21.7,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 39.5,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 37.1,
            inertia: '',
        }
    },
    {
        beltWidth: 750,
        rollerDia: 114.3,
        carry: {
            // rollerWeight: 12.6,
            rollerWeight: 20.4,
            idlerWeight: 24.1,
            inertia: '',
        },
        return: {
            // rollerWeight: 11.3,
            rollerWeight: 17.8,
            idlerWeight: 13.1,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 11.6,
            idlerWeight: 13.4,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 23.5,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 53.2,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 44.5,
            inertia: '',
        }
    },
    {
        beltWidth: 900,
        rollerDia: 114.3,
        carry: {
            // rollerWeight: 14.4,
            rollerWeight: 23.7,
            idlerWeight: 27.3,
            inertia: '',
        },
        return: {
            // rollerWeight: 13.1,
            rollerWeight: 20.6,
            idlerWeight: 14.9,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 13.3,
            idlerWeight: 15.1,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 28.8,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 58.6,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 57.3,
            inertia: '',
        }
    },
    {
        beltWidth: 1050,
        rollerDia: 139.8,
        carry: {
            // rollerWeight: 21.3,
            rollerWeight: 21.3,
            idlerWeight: 41.7,
            inertia: '',
        },
        return: {
            // rollerWeight: 19.4,
            rollerWeight: 18.9,
            idlerWeight: 22.2,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 20.9,
            idlerWeight: 23.7,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 33.2,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 79.4,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 75.2,
            inertia: '',
        }
    },
    {
        beltWidth: 1200,
        rollerDia: 139.8,
        carry: {
            // rollerWeight: 23.7,
            rollerWeight: 23.6,
            idlerWeight: 45.7,
            inertia: '',
        },
        return: {
            // rollerWeight: 21.7,
            rollerWeight: 21.1,
            idlerWeight: 24.5,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 23.2,
            idlerWeight: 26.0,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 50.9,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 85.1,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 79.7,
            inertia: '',
        }
    },
    {
        beltWidth: 1400,
        rollerDia: 165.2,
        carry: {
            // rollerWeight: 36.6,
            rollerWeight: 36.6,
            idlerWeight: 78.3,
            inertia: '',
        },
        return: {
            // rollerWeight: 32.9,
            rollerWeight: 32.6,
            idlerWeight: 39.4,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 34.3,
            idlerWeight: 40.8,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 55.8,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 158.5,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 140.3,
            inertia: '',
        }
    },
    {
        beltWidth: 1600,
        rollerDia: 165.2,
        carry: {
            // rollerWeight: 41.4,
            rollerWeight: 41.4,
            idlerWeight: 92.0,
            inertia: '',
        },
        return: {
            // rollerWeight: 36.9,
            rollerWeight: 36.6,
            idlerWeight: 43.5,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 38.4,
            idlerWeight: 45.0,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 97.2,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 178.6,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 152.9,
            inertia: '',
        }
    },
    {
        beltWidth: 1800,
        rollerDia: 165.2,
        carry: {
            // rollerWeight: 49.2,
            rollerWeight: 47.4,
            idlerWeight: 122.5,
            inertia: '',
        },
        return: {
            // rollerWeight: 47.2,
            rollerWeight: 42.5,
            idlerWeight: 53.4,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 49.3,
            idlerWeight: 55.5,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 106.8,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 211.2,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 186.1,
            inertia: '',
        }
    },
    {
        beltWidth: 2000,
        rollerDia: 165.2,
        carry: {
            // rollerWeight: 55.8,
            rollerWeight: 52.2,
            idlerWeight: 134.5,
            inertia: '',
        },
        return: {
            // rollerWeight: 51.6,
            rollerWeight: 46.5,
            idlerWeight: 57.9,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 54.0,
            idlerWeight: 60.3,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 145.7,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 226.9,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 199.7,
            inertia: '',
        }
    },
    {
        beltWidth: 2200,
        rollerDia: 165.2,
        carry: {
            // rollerWeight: 70.2,
            rollerWeight: 57.0,
            idlerWeight: 165.9,
            inertia: '',
        },
        return: {
            // rollerWeight: 63.1,
            rollerWeight: 54.1,
            idlerWeight: 69.3,
            inertia: '',
        },
        returnRubber: {
            rollerWeight: 65.5,
            idlerWeight: 71.7,
            inertia: '',
        },
        impact: {
            rollerWeight: '',
            idlerWeight: 158.5,
            inertia: '',
        },
        SAC: {
            rollerWeight: '',
            idlerWeight: 267.2,
            inertia: '',
        },
        SAR: {
            rollerWeight: '',
            idlerWeight: 234.6,
            inertia: '',
        }
    },
];


export const getIdlerInfo = (beltWidth, carrySpacing, returnSpacing, length, height, skirtLength) => {
    const Sc = Number(carrySpacing);
    const Sr = Number(returnSpacing);
    const L = Number(length);
    const H = Number(height);
    const Lsk = Number(skirtLength);
    const Leq = Math.ceil(Math.sqrt(Math.pow(L, 2) + Math.pow(H, 2)));

    // 수량 계산
    const getQty = (type) => {
        let qty = 0;

        switch(type) {
            case 'carry':
                qty = Math.ceil(Leq / Sc - Lsk / IMPACT_SPACING - Leq / SAC_SPACING);
                break;
            case 'impact':
                qty = Math.ceil(Lsk / IMPACT_SPACING);
                break;
            case 'SAC':
                qty = Math.ceil(Leq / SAC_SPACING);
                break;
            case 'return':
                qty = Math.ceil(Leq / Sr - Leq / SAR_SPACING);
                break;
            case 'SAR':
                qty = Math.ceil(Leq / SAR_SPACING);
                break;
            default:
        }
        return qty;
    }

    // 단위 중량 가져오기
    const getUnitWeight = (beltWidth, type) => {
        const selected = idlerData.find(item => item.beltWidth === Number(beltWidth));

        return Number(selected[type].idlerWeight);
    }

    const qtyCarry = getQty('carry');
    const unitWeightCarry = getUnitWeight(beltWidth, 'carry');
    const qtyImpact = getQty('impact');
    const unitWeightImpact = getUnitWeight(beltWidth, 'impact');
    const qtySAC = getQty('SAC');
    const unitWeightSAC = getUnitWeight(beltWidth, 'SAC');
    const qtyReturn = getQty('return');
    const unitWeightReturn = getUnitWeight(beltWidth, 'return');
    const qtySAR = getQty('SAR');
    const unitWeightSAR = getUnitWeight(beltWidth, 'SAR');

    const getTotalWeight = () => {
        return Math.ceil(
            qtyCarry * unitWeightCarry +
            qtyImpact * unitWeightImpact +
            qtySAC * unitWeightSAC +
            qtyReturn * unitWeightReturn +
            qtySAR * unitWeightSAR
        );
    }


    const idlers = {
        carry: {
            qty: qtyCarry,
            unitWeight: unitWeightCarry,
            weight: Math.ceil(qtyCarry * unitWeightCarry),
        },
        impact: {
            qty: qtyImpact,
            unitWeight: unitWeightImpact,
            weight: Math.ceil(qtyImpact * unitWeightImpact),
        },
        return: {
            qty: qtySAC,
            unitWeight: unitWeightSAC,
            weight: Math.ceil(qtySAC * unitWeightSAC),
        },
        SAC: {
            qty: qtyReturn,
            unitWeight: unitWeightReturn,
            weight: Math.ceil(qtyReturn * unitWeightReturn),
        },
        SAR: {
            qty: qtySAR,
            unitWeight: unitWeightSAR,
            weight: Math.ceil(qtySAR * unitWeightSAR),
        },
        weight: getTotalWeight()
    }

    return idlers;
} 




